<script setup lang="ts">
const props = defineProps<{
  product
}>()

const limit = 2
const modalColors = useUiDialog('modal-colors')

const relatedColorProducts = computed(() => {
  return props.product?.relatedColorProducts
})

const productImageUrl = (url: string, params: string) => {
  return `${url}${params}`
}
const link = (product: any) => {
  return `${product.url}`
}
</script>

<template>
  <div
    v-if="relatedColorProducts && relatedColorProducts.length"
    class="variations"
  >
    <div v-if="product?.color?.length"
         class="variations__heading"
    >
      <span>{{ $t('Color:') + ' ' }}</span>
      <span>{{ product.color.map((item) => item.label).join(', ') }}</span>
    </div>

    <div class="variations__content">
      <ul class="variations__list">
        <li class="variations__item current">
          <span class="variations__link">
            <span class="variations__visual">
              <img
                :src="productImageUrl(product?.image, '?f=rs:fit:96:115')"
                width="96"
                height="115"
                :alt="product?.name"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </span>
        </li>
        <li
          v-for="item in relatedColorProducts.slice(0, limit)"
          :key="item.id"
          class="variations__item"
        >
          <AppLink
            :to="link(item)"
            class="variations__link"
          >
            <span class="variations__visual">
              <img
                :src="productImageUrl(item.image, '?f=rs:fit:96:115')"
                width="96"
                height="115"
                :alt="item.name"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </AppLink>
        </li>
      </ul>

      <button
        v-if="relatedColorProducts.length > limit"
        type="button"
        class="variations__more"
        @click="modalColors.open"
      >
        +{{ relatedColorProducts.length - 5 }}
      </button>
    </div>

    <LazyUiDialog
      class="variants__modal"
      name="modal-colors"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        {{ $t('Colors') }}
      </template>

      <ul class="modal-colors__content">
        <li class="variations__item">
          <span class="variations__link current">
            <span class="variations__visual">
              <img
                :src="productImageUrl(product?.image, '?f=rs:fit:96:115')"
                width="65"
                height="65"
                :alt="product?.color?.[0]?.label"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </span>
          <!-- <pre>{{ product }}</pre> -->
        </li>
        <li
          v-for="item in relatedColorProducts"
          :key="item.id"
          class="variations__item"
        >
          <AppLink
            :to="link(item)"
            class="variations__link"
            @click="modalColors.close"
          >
            <span class="variations__visual">
              <img
                :src="productImageUrl(item.image, '?f=rs:fit:96:115')"
                width="65"
                height="65"
                :alt="item?.color?.[0]?.label"
                loading="lazy"
                class="variations__image"
              >
            </span>
          </AppLink>
        </li>
      </ul>
    </LazyUiDialog>
  </div>
</template>

<style>
  @import url("~layers/app/components/Product/RelatedColorProducts.css");
</style>
